import { useState, useCallback } from 'react';
import styled from 'styled-components';
import { CircularProgress, Typography } from '@mui/material';
import { FlexColumn, Flex, Button } from '@elementary/common-ui/components';
import { useScim } from '../hooks/useScim';
import ProvisioningConfigDialog from './ProvisioningConfigDialog';
import ProvisioningStatusChip from './ProvisioningStatusChip';
import ProvisioningSource from './ProvisioningSource';

const SectionContainer = styled(FlexColumn)`
  border: 1px solid ${({ theme }) => theme.palette.common.gray8};
  border-radius: 6px;
  padding: 24px 32px;
  gap: 16px;
`;

const SectionHeader = styled(Flex)`
  justify-content: space-between;
  align-items: center;
`;

const HeaderLeft = styled(Flex)`
  align-items: center;
  gap: 16px;
`;

const HeaderRight = styled(Flex)`
  align-items: center;
  gap: 16px;
`;

const ConfigRow = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.palette.common.gray8};
  border-radius: 6px;
  padding: 16px 20px;
  justify-content: space-between;
  align-items: center;
`;

const ProvisioningSection = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const scim = useScim();

  const handleOpenDialog = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setDialogOpen(false);
  }, []);

  return (
    <>
      <SectionContainer>
        <SectionHeader>
          <HeaderLeft>
            <Typography sx={{ fontWeight: 'bold' }}>Provisioning</Typography>
          </HeaderLeft>
          <HeaderRight>
            {scim.isLoading && <CircularProgress size={14} />}
            <Button variant="outlined" onClick={handleOpenDialog}>
              Configure
            </Button>
          </HeaderRight>
        </SectionHeader>

        {scim.data && (
          <ConfigRow>
            <ProvisioningSource source={scim.data.source} />
            <ProvisioningStatusChip status={scim.data.status} />
          </ConfigRow>
        )}
      </SectionContainer>

      <ProvisioningConfigDialog open={dialogOpen} onClose={handleCloseDialog} />
    </>
  );
};

export default ProvisioningSection;
